import React, { Component } from 'react';
import BravoLoader from './BravoLoader';

export default class LoadingFullScreen extends Component
{
    static defaultProps = {
        loading: true
    };

    render ()
    {
        return <BravoLoader loading={this.props.loading} variant="fullscreen" />;
    }
}
